import { useContext } from "react";
import { AuthContext, IAuthContext } from "../providers/AuthProvider";

export const useAuth = (): IAuthContext =>
  useContext<IAuthContext>(AuthContext);
